import React, { useEffect } from "react";
import { styled } from "@mui/system";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const MalpracticeContainer = styled("div")({
  height: "100vh",
  width: "100vw",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(180deg, #450a0a 0%, #1c1917 100%)",
  color: "white",
  textAlign: "center",
  padding: "20px",
  boxSizing: "border-box",
  fontFamily: "Arial, sans-serif",
});

const IconWrapper = styled("div")({
  width: "90px",
  height: "90px",
  borderRadius: "50%",
  backgroundColor: "rgba(239, 68, 68, 0.15)",
  border: "2px solid #ef4444",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
  boxShadow: "0 0 25px rgba(239, 68, 68, 0.4)",
});

const Title = styled("h1")({
  fontSize: "clamp(28px, 4vw, 44px)",
  margin: "0 0 12px 0",
  fontWeight: "bold",
  color: "#f87171",
  letterSpacing: "0.5px",
});

const Subtitle = styled("h2")({
  fontSize: "clamp(18px, 2.5vw, 24px)",
  margin: "0 0 20px 0",
  fontWeight: "600",
  color: "#fca5a5",
});

const Content = styled("p")({
  fontSize: "clamp(14px, 1.4vw, 17px)",
  lineHeight: "1.7",
  maxWidth: "620px",
  marginBottom: "30px",
  color: "#e5e7eb",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  padding: "20px 25px",
  borderRadius: "12px",
  border: "1px solid rgba(239, 68, 68, 0.3)",
});

const Malpractice = () => {
  useEffect(() => {
    // 1. Immediately wipe all credentials and session state
    sessionStorage.clear();
    localStorage.clear();

    // 2. Exit fullscreen if still active
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    }

    // 3. Trap back and forward navigation to keep user locked on malpractice screen
    const handlePopState = (e) => {
      window.history.pushState(null, null, window.location.pathname);
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <MalpracticeContainer>
      <div style={{ marginBottom: "15px" }}>
        <img
          src={require("../assets/images/sunwareLogo.png")}
          alt="Sunware Logo"
          width="110px"
        />
      </div>

      <IconWrapper>
        <WarningAmberRoundedIcon style={{ fontSize: "56px", color: "#ef4444" }} />
      </IconWrapper>

      <Title>Assessment Disqualified</Title>
      <Subtitle>Terminated Due to Proctoring Violations</Subtitle>

      <Content>
        Your test session has been <strong>automatically terminated and submitted</strong> because repeated security violations (such as switching tabs, leaving the exam window, or exiting full screen) were detected by our proctoring system.
        <br /><br />
        This attempt has been <strong>flagged as malpractice</strong> in our records and your score has been voided.
      </Content>

      <div
        style={{
          color: "#fca5a5",
          fontSize: "15px",
          fontWeight: "600",
          backgroundColor: "rgba(220, 38, 38, 0.2)",
          border: "1px solid rgba(220, 38, 38, 0.5)",
          padding: "12px 28px",
          borderRadius: "8px",
          marginTop: "10px",
          letterSpacing: "0.3px",
        }}
      >
        🔒 Screen Locked: Please contact your exam invigilator / administrator.
      </div>

      <div style={{ position: "fixed", bottom: "10px", right: "16px", fontSize: "12px", color: "rgba(255,255,255,0.5)" }}>
        © 2026 Sunware Technologies. All rights reserved.
      </div>
    </MalpracticeContainer>
  );
};

export default Malpractice;
